import { Breadcrumb } from 'antd';
import { FC } from 'react';
import { Link } from 'react-router-dom';

interface IProps {
	highlight_title: string;
}

export const HighlightsBreadcrumb: FC<IProps> = ({ highlight_title }) => (
	<Breadcrumb>
		<Breadcrumb.Item key='highlights'>
			<Link to={'/loja/destaques'}>Destaques</Link>
		</Breadcrumb.Item>
		<Breadcrumb.Item key='highlight'>{highlight_title}</Breadcrumb.Item>
	</Breadcrumb>
);
